import { ConfigOptions } from '../types/form'

export function createField(
    config: ConfigOptions,
    value: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelData: any
) {
    const id = `${config.name}-${Math.random().toString(36).substring(3)}`
    const input = document.createElement(
        config.type || (config.hideWhenValuePresent && value)
            ? 'input'
            : 'select'
    ) as HTMLInputElement
    input.id = id
    input.name = config.name

    if (config.fillMethod) {
        config.fillMethod(input)
    }

    if (config.type) {
        input.type = config.type
    } else if (config.hideWhenValuePresent && value) {
        input.type = 'hidden'
    }

    if (config.placeholder) {
        input.placeholder = config.placeholder
    }

    if (value) {
        input.value = value
    } else if (config.defaultValue) {
        input.value = config.defaultValue
    }

    if (config.handleSubmitOnBlur) {
        input.onblur = config.handleSubmitOnBlur
    }

    if (input.type === 'hidden') {
        return input
    }

    const field = document.createElement('div')
    field.className = `form-field  ${
        config.prefix ? 'form-field--prefixed' : ''
    }`

    if (config.prefix) {
        const prefix = document.createElement('div')
        prefix.className = 'form-field__prefix'
        prefix.innerHTML = config.prefix
        field.appendChild(prefix)
    }

    if (config.label) {
        const label = document.createElement('label')
        label.innerHTML =
            typeof config.label === 'function'
                ? config.label(labelData)
                : config.label
        label.setAttribute('for', id)
        field.appendChild(label)
    }

    field.appendChild(input)

    return field
}
